import { tryLoadDependencies, WebAwesomeComponent } from '../../Global/loadDependency'
import { getTemplateNavHeaderStyles } from '../NavHeaderContextual/NavHeaderContextual.styles'

const t = document.createElement('template')
t.innerHTML = `
    <!-- Contextual Button -->
  <div class="contextual-btn-container">
    <wa-button
      id="btnContextual"
      size="small"
      class="contextual-btn">
      <slot name="buttonText"></slot>
    </wa-button>
  </div>
`
class NavHeaderContextualButton extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Button])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {}
}

if (!customElements.get('ts-navheader-contextual-button')) {
  customElements.define('ts-navheader-contextual-button', NavHeaderContextualButton)
}
export { NavHeaderContextualButton }